import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CreateCommoditiesForm } from "web_myplann/Portfolio/Pages/CommoditiesCreate/CreateCommoditiesForm";
import { PortfolioAddLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioAddLayout";

export const AddCommoditiesPage = () => {
	const { t } = useResource();

	return (
		<PortfolioAddLayout title={t(Resources.Portfolio.AddCommodities.title)}>
			<CreateCommoditiesForm />
		</PortfolioAddLayout>
	);
};
